module.exports = __webpack_public_path__ + "img/20.88a6d1a5.png";